var React = require('react');

function ArrowLink (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 27.7138H61M39.6175 4L63.4015 27.3841M40.4541 51.2643L63.0358 28.2599","stroke":"currentColor","strokeWidth":"7","strokeLinecap":"round"}));
}

ArrowLink.defaultProps = {"width":"67","height":"55","viewBox":"0 0 67 55","fill":"none"};

module.exports = ArrowLink;

ArrowLink.default = ArrowLink;
